// 我发出的
import React, { useContext, useState, useEffect, useCallback } from "react";
import api from "../../api";
import contextMenus, { Names } from "../../contextMenus";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import batchOperate from "../../batchOperate";
import { MenuEnum, ShareType } from "../../components/List/SharesFilters/config";
import events from "../../context/events";
import TableList from "../../components/TableList";
import { ColumnsItem, JustifyContent } from "../../components/TableList/BaseComponents/Header";
import { getIconUrl, openLink, time } from "../../util";
import { changeEgovUrl } from "@/utils/tools";
import ContextMenu, { IContextRender } from "../../components/List/ContextMenu";
import { Icons } from "../../Icon";
import Tags, { TagType } from "../../components/Tags";
import openDeleteModal from "../../contextModal/DeleteModal";
import { pageSize } from "../../config/basics.config";
import { ActionFnEnum, ContextMenuMode, FileType, MenusType } from "../../types";
import SharesFilters from "../../components/List/SharesFilters";
import { isFocusEnv } from "@/utils";
import Bus from "@/utils/bus";
import UpdataService from "../../reloadUtils";
import { useNavigator } from "@/utils/NetworkCheck";
import SyncStatusTag from "../../components/SyncStatusTag";
import { useListData } from "../../components/TableList/Use/useListData";

const PartialUpdata = Object.create(UpdataService);
const key = MenusType.SHARE;
// 获取数据
const getList = (params: any) => {
  return new Promise((resolve, reject) => {
    api.pages
      .myshare(params)
      .then((res) => {
        if (res) {
          res.pages = (res.pages || []).map((item: any) => {
            item.time = time.format((item as any).shareAt);
            item.sharesType = item.share_method_Name || "";
            return item;
          });
        }
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export default function () {
  const globalContext = useContext<GlobalContextConfig>(GlobalContext);

  const {
    list,
    setList,
    total,
    setTotal,
    loading,
    isLoadMore,
    setLoadMore,
    setPageIndex,
    onButtom
  } = useListData({
    requestPagesFunc: getList,
    isEmitLoadMore: true,
    isFilter: false,
    isCategory: false,
    key
  });

  const [columns, setColumns] = useState<ColumnsItem[]>([
    { title: "标题", key: "title", dataIndex: "title", ellipsis: true },
    {
      title: "分享方式",
      key: "sharesType",
      dataIndex: "sharesType"
    },
    {
      title: "分享时间",
      key: "time",
      dataIndex: "time",
      width: "25%",
      style: {
        minWidth: "142px"
      },
      justifyContent: JustifyContent.Left
    },
    {
      title: "",
      key: "actions",
      dataIndex: "actions",
      actions: true,
      width: "5%",
      style: {
        minWidth: "30px"
      },
      justifyContent: JustifyContent.Center
    }
  ]);

  useEffect(() => {
    events.on("joyspace:onButtom", onButtom);
    return () => {
      events.off("joyspace:onButtom", onButtom);
    };
  }, [onButtom]);

  const openPage = (columnsItem: ColumnsItem, item: any) => {
    if (!item.status && useNavigator.onLine) {
      openDeleteModal(FileType.Page, item.id);
      return;
    }
    if (columnsItem.key === "title") {
      openLink(item, globalContext.appRuntimeEnv.joyspaceHost);
    }
  };
  return (
    <div
      className={isFocusEnv() ? "joyspace-list-table joyspace-list-share" : "joyspace-list-table"}
    >
      <TableList
        isLoadMore={isLoadMore}
        from={Names.MY_SHARE}
        columns={columns}
        list={list}
        loading={loading}
        pagination={false}
        folderFrom={{ draggerUploadShow: true }}
        renderActions={(item: any, contextMenuMode = ContextMenuMode.Click) => {
          if (item.isDisabled) {
            return (
              <span className="joyspace-trigger-icon" style={{ color: "#cccccc" }}>
                {Icons.trigger}
              </span>
            );
          }
          return (
            <ContextMenu
              render={contextMenus.page(Names.MY_SHARE, globalContext)}
              callbackProps={{
                contextMenuMode,
                originId: "",
                data: item,
                setData: (data: any) => {
                  events.emit("list.partial.refresh", {
                    changeData: data,
                    key
                  });
                },
                remove: () => {
                  console.log("remove");
                },
                reload: () => {
                  console.log("reload");
                }
              }}
            />
          );
        }}
        preOptions={(item: any, data: any, isExist: any) => {
          return (
            item.dataIndex === "title" && (
              <img
                src={
                  !isExist ? changeEgovUrl(data.icon_url) : getIconUrl(data.type || data.page_type)
                }
                data-icon
              />
            )
          );
        }}
        afterOptions={(item, data) => {
          return (
            item.dataIndex === "title" &&
            data.isCollected && <Tags left={5} TagType={TagType.Follow} />
          );
        }}
        onButtom={onButtom}
        handleItem={openPage}
        contentRender={(columnsItem: ColumnsItem, item: any) => {
          if (columnsItem.dataIndex === "time" && item.isNew) {
            return <SyncStatusTag status={item.syncStatus} />;
          }
        }}
      />
    </div>
  );
}
